import React, { useState, useEffect } from "react";
import Pajination from "../../../helpingFiles/Pagination/Pajination";
import "bootstrap/dist/css/bootstrap.min.css";
import SideBar from "../../../Components/Navbar/Sidebar";
import instance from "../../../Components/Apis/axios";
import Head from "../../../Components/ontabletop/head";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../../Components/loader";

const Accept = () => {
  const navigation = useNavigate();
  const locations = useLocation();
  const path = locations.pathname;
  const [loading, setLoading] = useState(false);
  const [posts, setPosts] = useState([]);
  const [total, setTotal] = useState("");
  const [page, setPage] = useState(1);
  const [postPerpage, setPostPerPage] = useState(10);
  const [query, setQuery] = useState("");

  const fatchData = async () => {
    setLoading(true);
    const { data } = await instance.get(`syncMedia/accepts?path=${path}`);
    if (data.message == "You are not authorized for this page") {
      navigation("/");
    } else {
      setPosts(data);
      setTotal(data.length);
      setLoading(false);
    }
  };

  useEffect(() => {
    fatchData();
  }, [setPosts]);

  const reject = async (id, e) => {
    e.preventDefault();
    const { data } = await instance.put(`syncMedia/accepts?path=${path}`, {
      id: id,
    });
    if (data.message == "You are not authorized for this Action") {
      alert(data.message);
    } else {
      fatchData();
    }
  };

  const accept = async (
    allocate_end_date,
    allocate_start_date,
    areadescription,
    available_date,
    block_limit,
    category_id,
    city,
    client,
    clientCode,
    code,
    created_date,
    district,
    foot_fall,
    ftf,
    geolocation,
    height,
    heightunit,
    id,
    illumination,
    isBlocked,
    isBooked,
    isDelete,
    is_goh_update,
    lhs_rhs,
    location,
    medianame,
    modify_date,
    owner,
    price,
    pricetype,
    saleasbunch,
    searchingkeywords,
    slot_duration,
    slot_per_day,
    state,
    status,
    sub_category_id,
    syncdescription,
    syncstatus,
    thumbnail,
    totalno,
    width,
    widthunit
  ) => {
    const { data } = await instance.put(`syncMedia/rejects/?path=${path}`, {
      allocate_end_date: allocate_end_date,
      allocate_start_date: allocate_start_date,
      areadescription: areadescription,
      available_date: available_date,
      block_limit: block_limit,
      category_id: category_id,
      city: city,
      client: client,
      clientCode: clientCode,
      code: code,
      created: created_date,
      district: district,
      foot_fall: foot_fall,
      ftf: ftf,
      geolocation: geolocation,
      height: height,
      heightunit: heightunit,
      id: id,
      illumination: illumination,
      isBlocked: isBlocked,
      isBooked: isBooked,
      isDelete: isDelete,
      is_goh_update: is_goh_update,
      lhs_rhs: lhs_rhs,
      location: location,
      medianame: medianame,
      modify_date: modify_date,
      owner: owner,
      price: price,
      pricetype: pricetype,
      saleasbunch: saleasbunch,
      searchingkeywords: searchingkeywords,
      slot_duration: slot_duration,
      slot_per_day: slot_per_day,
      state: state,
      status: status,
      sub_category_id: sub_category_id,
      syncstatus: syncstatus,
      syncdescription: syncdescription,
      thumbnail: thumbnail,
      totalno: totalno,
      width: width,
      widthunit: widthunit,
    });
    if (data.message === "You are not authorized for this Action") {
      alert(data.message);
    } else {
      fatchData();
    }
  };

  const indexOfLastPage = page * postPerpage;
  const indexOfFirstPage = indexOfLastPage - postPerpage;
  const currentPosts = posts.slice(indexOfFirstPage, indexOfLastPage);
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "numeric", day: "numeric" };
    const formattedDate = new Date(dateString).toLocaleDateString(
      undefined,
      options
    );
    return formattedDate;
  };



  return (
    <>
      {posts && (
        <div>
          <div className="containers">
            <div className="container-sidebar">
              <SideBar />
            </div>
            <div className="container-pages">
              <div className="page-title">
                <h2>UnSync Media</h2>
              </div>
              <Head setPostPerPage={setPostPerPage} setQuery={setQuery} />
              {loading ? (
                <Loader />
              ) : (
                <>
                  {currentPosts.length == 0 ? (
                    <h2 className="text-secondary">No Media found</h2>
                  ) : (
                    <>
                      <table className="table table-boarder table-hover table-striped  table-sm">
                        <thead className="thead-dark">
                          <tr className="text-center">
                            <th scope="col">ID</th>
                            <th scope="col">Image</th>
                            <th scope="col">Media Code</th>
                            <th scope="col">Media Location</th>
                            <th scope="col">Status</th>
                            <th scope="col">Vendor</th>
                            <th scope="col">Create Date</th>
                            <th scope="col">Action Reject</th>
                            <th scope="col">Action Accept</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* putting data on table by map function */}
                          {currentPosts
                            .filter((obj) => {
                              if (query == "") {
                                return obj;
                              } else if (
                                obj.code
                                  .toLowerCase()
                                  .includes(query.toLowerCase()) ||
                                obj.medianame
                                  .toLowerCase()
                                  .includes(query.toLowerCase()) ||
                                obj.syncstatus
                                  .toLowerCase()
                                  .includes(query.toLowerCase()) ||
                                obj.clientCode
                                  .toLowerCase()
                                  .includes(query.toLowerCase())
                              ) {
                                return obj;
                              }
                            })
                            .map((pos, index) => (
                              <tr key={pos.id}>
                                <td>{index + 1}</td>
                                <td style={{ width: "20%" }}>
                                  {pos.thumbnail ? (
                                    <img
                                      src={pos.thumbnail}
                                      alt={pos.medianame}
                                      style={{ width: "50%" }}
                                    />
                                  ) : (
                                    "No Image Found"
                                  )}{" "}
                                </td>
                                <td>{pos.code}</td>
                                <td>{pos.medianame}</td>
                                <td>{pos.syncstatus}</td>
                                <td>{pos.clientCode}</td>
                                <td>{formatDate(pos.created_date)}</td>
                                <td>
                                  <button
                                    onClick={(e) => reject(pos.id, e)}
                                    className="button is-small border-0  btn-danger "
                                  >
                                    Reject
                                  </button>
                                </td>
                                <td>
                                  <button
                                    // onClick={() => accept(pos.clientCode,pos.id,pos.allocate_end_date,pos.city)}
                                    onClick={() =>
                                      accept(
                                        pos.allocate_end_date,
                                        pos.allocate_start_date,
                                        pos.areadescription,
                                        pos.available_date,
                                        pos.block_limit,
                                        pos.category_id,
                                        pos.city,
                                        pos.client,
                                        pos.clientCode,
                                        pos.code,
                                        pos.created_date,
                                        pos.district,
                                        pos.foot_fall,
                                        pos.ftf,
                                        pos.geolocation,
                                        pos.height,
                                        pos.heightunit,
                                        pos.id,
                                        pos.illumination,
                                        pos.isBlocked,
                                        pos.isBooked,
                                        pos.isDelete,
                                        pos.is_goh_update,
                                        pos.lhs_rhs,
                                        pos.location,
                                        pos.medianame,
                                        pos.modify_date,
                                        pos.owner,
                                        pos.price,
                                        pos.pricetype,
                                        pos.saleasbunch,
                                        pos.searchingkeywords,
                                        pos.slot_duration,
                                        pos.slot_per_day,
                                        pos.state,
                                        pos.status,
                                        pos.sub_category_id,
                                        pos.syncdescription,
                                        pos.syncstatus,
                                        pos.thumbnail,
                                        pos.totalno,
                                        pos.width,
                                        pos.widthunit
                                      )
                                    }
                                    className="button is-small btn-success border-0 "
                                  >
                                    Accept
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </>
                  )}
                </>
              )}
            </div>
          </div>


        </div>
      )}
    </>
  );
};
export default Accept;
